import { render, staticRenderFns } from "./FluxoColocacaoVaso.vue?vue&type=template&id=1ad8c595&scoped=true"
import script from "./FluxoColocacaoVaso.vue?vue&type=script&lang=js"
export * from "./FluxoColocacaoVaso.vue?vue&type=script&lang=js"
import style0 from "./FluxoColocacaoVaso.vue?vue&type=style&index=0&id=1ad8c595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8c595",
  null
  
)

export default component.exports